package com.essntl.features.service.domain.model.supplierservice

import com.essntl.features.organization.domain.model.OrganizationModel
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.features.supplier.domain.model.SupplierModel

data class SupplierServiceModel(
    val id: String,
    val createdAt: String,
    val createdBy: String?,
    val service: ServiceModel,
    val supplier: SupplierModel,
    val organization: OrganizationModel,
) {
    companion object {
        val empty =
            SupplierServiceModel(
                id = "",
                createdAt = "",
                createdBy = null,
                service = ServiceModel.empty,
                supplier = SupplierModel.empty,
                organization = OrganizationModel.empty,
            )
    }
}